import React from 'react';
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import { LANGUAGES, BRANCHES, ENVIRONMENTS, RATIOS, SIZES } from '../utils/config';

const SRGLetterboxPlayerSettings = ({ letterbox, lang, env, branch, URN, debug, storage, resizable, ratio, api, mobile, playerBar, size, standalone, continuousPlayback, recommendations, castAppId, subtitle }) => {
  return (
    <>
      <h1 className="content__title">Settings</h1>
      <div className="form-control">
        <label htmlFor="storage">User Storage : </label>
        <Toggle
          defaultChecked={storage}
          disabled={!letterbox?.isNewApi}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setStorage(evt.target.checked)} />
      </div>
      <div className="form-control">
        <label htmlFor="debug">Debug Mode : </label>
        <Toggle
          defaultChecked={debug}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setDebug(evt.target.checked)} />
      </div>

      <div className="form-control">
        <label htmlFor="debug">C.Playback : </label>
        <Toggle
          defaultChecked={continuousPlayback}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setContinuousPlayback(evt.target.checked)} />
      </div>

      <div className="form-control">
        <label htmlFor="debug">Recos : </label>
        <Toggle
          defaultChecked={recommendations}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setRecommendations(evt.target.checked)} />
      </div>

      <div className="form-control form-resizable-mode">
        <label htmlFor="resizable">Resizable Mode : </label>
        <Toggle
          defaultChecked={resizable}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setResizable(evt.target.checked)} />
      </div>

      <div className="form-control form-mobile-mode">
        <label htmlFor="mobile">Mobile Mode : </label>
        <Toggle
          defaultChecked={mobile}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setMobile(evt.target.checked)} />
      </div>

      <div className="form-control form-bar-mode">
        <label htmlFor="playerBar">Player Bar : </label>
        <Toggle
          defaultChecked={playerBar}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setPlayerBar(evt.target.checked)} />
      </div>

      <div className="form-control form-standalone-mode">
        <label htmlFor="standalone">Standalone : </label>
        <Toggle
          defaultChecked={standalone}
          icons={false}
          className='srg-toggle'
          onChange={evt => api.setStandalone(evt.target.checked)} />
      </div>

      <div className="form-control form-size-mode">
        <label htmlFor="size">Size : </label>
        <select name="size" id="size" value={size} onChange={evt => api.setSize(evt.target.value)}>
          {SIZES.map(size => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </div>

      <div className="form-control">
        <label htmlFor="lang">UI Language : </label>
        <select name="lang" id="lang" value={lang} onChange={evt => api.setLang(evt.target.value)}>
          {LANGUAGES.map(lang => (
            <option key={lang.code} value={lang.code}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-control">
        <label htmlFor="ratio">Aspect Ratio : </label>
        <select name="ratio" id="ratio" value={ratio} onChange={evt => api.setRatio(evt.target.value)}>
          {RATIOS.map(({ format }, index) => (
            <option key={index} value={index}>
              {format}
            </option>
          ))}
        </select>
      </div>

      <div className="form-control">
        <label htmlFor="branch">Branch : </label>
        <select
          name="branch"
          id="branch"
          value={branch}
          onChange={evt => api.setBranch(evt.target.value)}
        >
          {BRANCHES.map(branchValue => (
            <option key={branchValue.value} value={branchValue.value}>
              {branchValue.label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-control">
        <label htmlFor="env">Environment : </label>
        <select name="env" id="env" value={env} onChange={evt => api.setEnv(evt.target.value)}>
          {ENVIRONMENTS.map(envValue => (
            <option key={envValue.host} value={envValue.host}>
              {envValue.title}
            </option>
          ))}
        </select>
      </div>

      <div className="form-control">
        <label htmlFor="urn">URN : </label>
        <input name="urn" id="urn" value={URN} onChange={evt => api.setURN(evt.target.value)} />
      </div>
      <div className="form-control">
        <label htmlFor="castAppId">Cast APPID : </label>
        <input name="castAppId" id="castAppId" value={castAppId} onChange={evt => api.setCastAppId(evt.target.value)} />
      </div>
      <div className="form-control">
        <label htmlFor="subtitle">Default Subtitle: </label>
        <select name="subtitle" id="subtitle" value={subtitle} onChange={evt => api.setSubtitle(evt.target.value)}>
        <option key="none" value="false">
           None
        </option>
          {LANGUAGES.map(lang => (
            <option key={lang.code} value={lang.code}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>
    </>
  );
};

export default SRGLetterboxPlayerSettings;
